import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  resultCardWrapper: {
    fontFamily: Theme.typography.base.regular,
    backgroundColor: Theme.palette.white,
    borderRadius: '5px',
    marginTop: '20px',
    boxShadow: '0px 2px 4px 0 rgba(6,21,86,0.15)',
  },
  resultCard: {
    padding: '0',
    '&:last-child': {
      paddingBottom: '0',
    },
  },
  overridePagination: {
    '& button': {
      color: Theme.palette.primary.light,
    },
    color: Theme.palette.gray[750],
    '&.MuiTablePagination-root': {
      marginTop: '30px',
      marginBottom: '20px',
    },
    '& button:last-child': {
      paddingRight: '0',
    },
    [Theme.breakpoints.down('lg')]: {
      '&.MuiTablePagination-root': {
        marginBottom: '10px',
      },
    },
    [Theme.breakpoints.down('md')]: {
      '&.MuiTablePagination-root': {
        marginBottom: '30px',
      },
    },
    [Theme.breakpoints.down('sm')]: {
      '&.MuiTablePagination-root': {
        marginTop: '20px',
      },
    },
  },
}));

export default useStyles;
